import { useRefinementList } from 'react-instantsearch';
import styles from '../filterSkus.module.scss';
import { useState } from 'react';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
type CustomRefinementListProps = {
  attribute: string;
  label: string;
};
const CustomRefinementListDesktop = ({
  attribute,
}: CustomRefinementListProps) => {
  const { createURL, items, refine, canRefine } = useRefinementList({
    attribute,
    limit: 100,
  });
  const [limit, setLimit] = useState(5);
  const [search, setSearch] = useState('');
  const { t: tCommon } = useTranslation('common');

  return (
    <div>
      <form
        style={{ height: 33, marginBottom: 10 }}
        className="ais-SearchBox-form"
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          disabled={!canRefine}
          style={{ borderRadius: 9 }}
          className="ais-SearchBox-input"
          aria-label="Search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={translationFallback(
            'search',
            tCommon('search'),
            'search'
          )}
          spellCheck="false"
          maxLength={512}
          type="search"
          value={search}
          onChange={(e) => {
            if (e.target.value.length > 0) {
              setLimit(100);
              setSearch(e.target.value);
            } else {
              setLimit(5);
              setSearch('');
            }
          }}
        />
      </form>
      <ul className="ais-RefinementList-list  d-flex flex-column gap-2">
        {items
          .filter((seachItem) => {
            if (search === '') return true;
            return seachItem.label.toLowerCase().includes(search.toLowerCase());
          })
          .slice(0, limit)
          .map((item) => (
            <li
              key={item.label}
              style={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
              className="ais-RefinementList-label font-size-14 fw-500"
            >
              <input
                readOnly
                disabled={!canRefine}
                className={`ais-RefinementList-checkbox  ${item.isRefined ? styles.checkboxChecked : ''}`}
                type="checkbox"
                checked={item.isRefined}
                value={item.value}
              />
              <span className="ais-RefinementList-labelText">{item.label}</span>
              <span
                className={`${styles.filterCount} ais-RefinementList-count`}
                style={{ padding: '3px 7px' }}
              >
                {item.count}
              </span>
            </li>
          ))}
      </ul>
      {items.length > 5 && (
        <div className="text-left">
          <button
            className="ais-RefinementList-showMore px-3"
            style={{ border: '1px solid #ccc' }}
            onClick={() => setLimit(limit === 5 ? -1 : 5)}
          >
            {limit === 5
              ? translationFallback(
                  'show_more',
                  tCommon('show_more'),
                  'Show more'
                )
              : translationFallback(
                  'show_less',
                  tCommon('show_less'),
                  'Show less'
                )}
          </button>
        </div>
      )}
    </div>
  );
};

export default CustomRefinementListDesktop;
